import { useDispatch } from "react-redux";
import { closeModal } from "../../../features/modalSLice";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, CircleX, Save, Trash2 } from "lucide-react";
import { loadStatus } from "../../../util";

const ResourseButtons = ({ link, text, to, loading, red, submitText }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCancelClick = (e) => {
    e.preventDefault();
    if (link) {
      if (to) {
        navigate(to);
      } else navigate(-1);
    } else {
      dispatch(closeModal());
    }
  };

  return (
    <div className="flex justify-between items-center py-7">
      <button
        onClick={handleCancelClick}
        disabled={loading === loadStatus.loading}
        className={`${red ? "red-cancel-rss-btn" : "cancel-rss-btn"} `}
      >
        {text && text.toLowerCase() === "back" ? (
          <ChevronLeft size={18} />
        ) : (
          <CircleX size={18} />
        )}
        {text ? text : "Cancel"}
      </button>
      <button
        type="submit"
        disabled={loading === loadStatus.loading}
        className={`${red ? "delete-rss-btn" : "add-rss-btn"} `}
      >
        {(submitText && submitText?.toLowerCase() === "delete") || red ? (
          <Trash2 size={18} />
        ) : (
          <Save size={18} />
        )}
        {submitText ? submitText : "Submit"}
      </button>
    </div>
  );
};

export default ResourseButtons;
